<template>
  <div class="analysis-page">
    <div class="page-wrapper">
      <!-- 页面标题 + 右上角按钮 -->
      <div class="page-header">
        <h2>五大领域分析</h2>
        <div class="header-actions">
          <button @click="handleShowSave" class="btn btn-primary btn-small">
            保存案例
          </button>
          <!-- <button class="btn btn-default btn-small">导出word</button>
          <button class="btn btn-default btn-small">导出pdf</button> -->
        </div>
      </div>

      <!-- 核心布局：左右分栏 -->
      <div class="main-container">
        <!-- 左侧主栏目 -->
        <div class="left-column">
          <div class="card-wrapper">
            <div class="module-title">学生信息与观察白描</div>
            <div class="student-info-row">
              <input
                v-model="studentNameLocal"
                class="input-control"
                placeholder="请输入学生姓名"
              />
              <div class="rating-star">
                <span
                  v-for="i in 5"
                  :key="i"
                  class="star"
                  :class="{ active: i <= rating }"
                  >★</span
                >
              </div>
            </div>

            <textarea
              v-model="observationContent"
              class="textarea-control"
              rows="5"
              placeholder="请输入观察白描内容..."
            ></textarea>

            <div class="btn-group">
              <button
                @click="handleAnalysis"
                :disabled="loading.field"
                class="btn btn-primary"
              >
                分析
              </button>
              <button @click="checkText" class="btn btn-default">
                检查白描规范性
              </button>
              <button @click="clearOutput" class="btn btn-default">清除</button>
            </div>
          </div>
          <div v-if="bot_text2.streamOutput" class="card-wrapper">
            <a-spin v-if="loading.text2" :spinning="loading.field">
              <div>思考中</div>
            </a-spin>
            <div
              :key="bot_text2.streamOutput"
              class="coze-markdown"
              style="min-height: 200px; overflow: auto;"
            >
              <vue-markdown :source="bot_text2.streamOutput"></vue-markdown>
            </div>
            <!-- <div class="content" v-html="bot_filed.streamOutput"></div> -->
          </div>
          <div class="card-wrapper">
            <div class="flex-row">
              <div class="module-title" style="padding-bottom:0">
                分析结果（可复制）
              </div>
              <a-button
                v-if="bot_filed.streamOutput"
                :disabled="loading.field"
                type="primary"
                size="small"
                @click="copyOutput"
                >采用领域和行为表现</a-button
              >
            </div>
            <a-spin v-if="loading.field" :spinning="loading.field">
              <div>思考中</div>
            </a-spin>
            <div
              :key="bot_filed.streamOutput"
              class="coze-markdown"
              style="min-height: 200px; overflow: auto;"
            >
              <vue-markdown :source="bot_filed.streamOutput"></vue-markdown>
            </div>
            <!-- <div class="content" v-html="bot_filed.streamOutput"></div> -->
          </div>
          <!-- 分析结果模块 -->

          <!-- 五大领域评分模块 -->
          <div class="card-wrapper">
            <div class="module-title">五大领域评分（可手动校正）</div>
            <div class="score-container">
              <div ref="radarChart" class="radar-chart"></div>
              <div class="score-slider-group">
                <div class="slider-item">
                  <label>健康：</label>
                  <a-slider
                    v-model="scores.health"
                    :min="0"
                    :max="5"
                    class="slider-control"
                  />
                  <span>{{ scores.health }}</span>
                </div>
                <div class="slider-item">
                  <label>语言：</label>
                  <a-slider
                    v-model="scores.language"
                    :min="0"
                    :max="5"
                    class="slider-control"
                  />
                  <span>{{ scores.language }}</span>
                </div>
                <div class="slider-item">
                  <label>社会：</label>
                  <a-slider
                    v-model="scores.social"
                    :min="0"
                    :max="5"
                    class="slider-control"
                  />
                  <span>{{ scores.social }}</span>
                </div>
                <div class="slider-item">
                  <label>科学：</label>
                  <a-slider
                    v-model="scores.science"
                    :min="0"
                    :max="5"
                    class="slider-control"
                  />
                  <span>{{ scores.science }}</span>
                </div>
                <div class="slider-item">
                  <label>艺术：</label>
                  <a-slider
                    v-model="scores.art"
                    :min="0"
                    :max="5"
                    class="slider-control"
                  />
                  <span>{{ scores.art }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 案例库模块 -->
          <div class="card-wrapper">
            <div class="head">
              <div class="module-title">案例库（本地）</div>
              <!--分页-->
              <a-pagination
                show-less-items
                :defaultPageSize="pageInfo.pageSize"
                size="small"
                :current="pageInfo.currentPage"
                :total="pageInfo.total"
                @change="onChangeExm"
              />
            </div>
            <div class="case-list">
              <div
                class="case-item"
                v-for="(item, index) in caseList"
                :key="index"
              >
                <div class="case-header">
                  <span class="case-name">{{ item.student_name }}</span>
                  <span class="case-time">{{ item.addTime }}</span>
                </div>
                <div class="case-actions">
                  <button
                    @click="handleChangeCase(item)"
                    class="btn btn-small btn-primary"
                  >
                    加裁
                  </button>
                  <!-- <button class="btn btn-small btn-default">导出</button> -->
                  <button
                    @click="handleDeleteCase(item)"
                    class="btn btn-small btn-danger"
                  >
                    删除
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧副功能区 -->
        <div class="right-column">
          <div class="card-wrapper">
            <div class="module-title">上传与识别工具</div>

            <!-- 图片解析模块（新增上传/删除） -->
            <div class="tool-item">
              <div class="tool-title">已上传图片（作品或连续动作）</div>
              <!-- 新增：图片上传按钮 -->
              <div class="upload-btn-group">
                <label class="upload-btn btn btn-primary btn-small">
                  {{ loading.uploadImage ? "上传中..." : "上传图片" }}
                  <input
                    type="file"
                    accept="image/jpeg,image/png,image/gif,image/bmp,image/heic,.jpg,.jpeg,.png,.gif,.bmp,.heic"
                    multiple
                    @change="uploadImage"
                    class="file-input"
                    :disabled="loading.uploadImage"
                  />
                </label>
              </div>
              <!-- 图片预览 + 删除按钮 -->
              <div class="upload-preview">
                <div
                  class="preview-item"
                  v-for="(img, index) in uploadedImages"
                  :key="index"
                >
                  <img :src="img.url" class="preview-img" />
                  <div class="loading-overlay" v-if="img.uploading">
                    <span class="loading-spinner"></span>
                  </div>
                  <button class="delete-btn" @click="deleteImage(index)">
                    ×
                  </button>
                </div>
              </div>
              <button
                @click="handleCreateWhiteboard"
                class="btn btn-primary btn-block"
                :disabled="loading.createWhiteboard || !uploadedImages.length"
              >
                {{
                  loading.createWhiteboard
                    ? "生成中..."
                    : "根据图片内容生成白描"
                }}
              </button>
              <div class="tool-desc">
                白描结果（识别/手动粘贴）
                <a-icon
                  type="copy"
                  style="cursor: pointer;"
                  @click="copyToClipboard(bot_image.streamOutput)"
                />
              </div>
              <a-textarea
                v-model="bot_image.streamOutput"
                placeholder="白描结果将展示在这里，可编辑..."
                :auto-size="{ minRows: 3 }"
                allowClear
              ></a-textarea>
            </div>

            <!-- 音频解析模块（新增上传/删除） -->
            <div class="tool-item">
              <div class="tool-title">已上传音频</div>
              <!-- 新增：音频上传按钮 -->
              <div class="upload-btn-group">
                <label class="upload-btn btn btn-primary btn-small">
                  {{ loading.uploadAudio ? "上传中..." : "上传音频" }}
                  <input
                    type="file"
                    accept="audio/*"
                    @change="uploadAudio"
                    class="file-input"
                    :disabled="loading.uploadAudio"
                  />
                </label>
              </div>
              <!-- 音频项 + 删除按钮 -->
              <div v-if="uploadedAudio.length > 0">
                <div
                  class="audio-item"
                  v-for="(audio, index) in uploadedAudio"
                  :key="index"
                >
                  <div class="audio-name">
                    {{ audio.name }}
                  </div>
                  <a-icon
                    style="margin-left: 8px;"
                    type="delete"
                    @click="deleteAudio(index)"
                  />
                  <!-- 音频加载指示器 -->
                  <div class="loading-overlay" v-if="audio.uploading">
                    <div class="loading-spinner"></div>
                  </div>
                </div>
              </div>

              <div class="audio-placeholder" v-else>
                暂无上传的音频文件
              </div>
              <button
                class="btn btn-primary btn-block"
                :disabled="!uploadedAudio.length || loading.audioToText"
                @click="handleAudioToText"
              >
                {{ loading.audioToText ? "转换中..." : "音频转文字" }}
              </button>
              <div class="tool-desc">
                转写结果（识别/手动粘贴）
                <a-icon
                  type="copy"
                  style="cursor: pointer;"
                  @click="copyToClipboard(bot_audio.streamOutput)"
                />
              </div>
              <a-textarea
                v-model="bot_audio.streamOutput"
                placeholder="转写结果将展示在这里..."
                :auto-size="{ minRows: 3 }"
                allowClear
              ></a-textarea>
              <button
                class="btn btn-primary btn-block"
                :disabled="
                  !uploadedAudio.length || loading.createAudioWhiteboard
                "
                @click="handleCreateAudioWhiteboard"
              >
                {{
                  loading.createAudioWhiteboard
                    ? "生成中..."
                    : "根据音频内容生成白描"
                }}
              </button>
              <div class="tool-desc">
                白描结果（识别/手动粘贴）
                <a-icon
                  type="copy"
                  style="margin-left: 8px; cursor: pointer;"
                  @click="copyToClipboard(bot_text.streamOutput)"
                />
              </div>
              <a-textarea
                v-model="bot_text.streamOutput"
                placeholder="白描结果将展示在这里..."
                :auto-size="{ minRows: 3 }"
                allowClear
              ></a-textarea>
            </div>

            <!-- 视频解析模块（新增上传/删除） -->
            <div class="tool-item">
              <div class="tool-title">已上传视频抽帧</div>
              <!-- 新增：视频上传按钮 -->
              <div class="upload-btn-group">
                <label class="upload-btn btn btn-primary btn-small">
                  上传视频
                  <input
                    type="file"
                    accept="video/*"
                    @change="uploadVideo"
                    class="file-input"
                  />
                </label>
              </div>
              <!-- 视频抽帧预览 + 删除按钮 -->
              <div class="video-frames" v-if="videoFrames.length > 0">
                <div
                  class="frame-item"
                  v-for="(frame, index) in videoFrames"
                  :key="index"
                  :class="{ selected: frame.selected }"
                  @click="toggleFrameSelection(index)"
                >
                  <img :src="frame.src" class="frame-img" />
                  <div v-if="frame.selected" class="check-mark">✓</div>
                </div>
                <!-- 新增：清空所有抽帧按钮 -->
                <button
                  class="btn btn-small btn-danger mt-8"
                  @click="clearAllFrames"
                >
                  清空抽帧
                </button>
              </div>
              <div class="video-placeholder" v-else>
                暂无上传的视频文件或抽帧
              </div>
              <button
                class="btn btn-primary btn-block"
                :disabled="!videoFrames.length || loading.createVideoWhiteboard"
                @click="handleCreateVideoWhiteboard"
                :loading="loading.createVideoWhiteboard"
              >
                {{
                  loading.createVideoWhiteboard
                    ? "生成中..."
                    : "根据视频内容生成白描"
                }}
              </button>
              <div class="tool-desc">
                白描结果（识别/手动粘贴）
                <a-icon
                  type="copy"
                  style="margin-left: 8px; cursor: pointer;"
                  @click="copyToClipboard(bot_video.streamOutput)"
                />
              </div>
              <a-textarea
                v-model="bot_video.streamOutput"
                placeholder="白描结果将展示在这里..."
                :auto-size="{ minRows: 3 }"
                allowClear
              ></a-textarea>
            </div>
          </div>
        </div>
      </div>
      <!--保存弹窗，可以新建保存或者覆盖已有记录保存-->
      <a-modal
        title="保存记录"
        :visible.sync="showSaveType"
        width="600px"
        @cancel="showSaveType = false"
        @ok="handleSave"
      >
        <div class="flex">
          <div
            @click="selectIndex = -1"
            class="check-item"
            :class="{ select: selectIndex == -1 }"
          >
            +新建保存
          </div>
          <div
            v-if="recordId !== ''"
            @click="selectIndex = 0"
            class="check-item"
            :class="{ select: selectIndex == 0 }"
          >
            覆盖保存
            <div class="tip">
              当前编辑
            </div>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { mapState } from "vuex";
import axios from "axios";
import qs from "qs";
import { batchUploadFilesToCoze, uploadFileToCoze } from "../../js/cozeUpload";
import {
  send_coze_image,
  send_coze_audio_to_text,
  send_coze_audio_to_whiteboard,
  send_coze_video_frames,
  send_coze_text_non_stream,
  send_coze_field,
  send_coze_to_whiteboard,
} from "../../js/coze";
import VueMarkdown from "vue-markdown";
import { aiApi, reportApi } from "../../api/api-director";

export default {
  name: "AiRecord",
  props: {
    studentName: {
      type: String,
      default: "",
    },
    studentId: {
      type: String,
      default: "",
    },
    analysisImages: {
      type: Array,
      default: () => [],
    },
    analysisAudioUrl: {
      type: String,
      default: "",
    },
    analysisVideoUrl: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState(["userInfo", "headers"]),
  },
  watch: {
    userInfo: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.initToken();
        }
      },
      immediate: true, // 立即执行一次，确保在 token 存在时初始化
    },
    // 监听分析图片数组变化
    analysisImages: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.uploadedImages = newVal.map((img) => ({
            id: img || "",
            url: img || "",
            uploading: false,
          }));
        } else {
          this.uploadedImages = [];
        }
      },
      deep: true,
    },
    // 监听分析音频文件地址变化
    analysisAudioUrl: {
      handler(newVal) {
        if (newVal) {
          this.uploadedAudio = [
            {
              id: newVal,
              name: newVal.split("/").pop() || "audio.mp3",
              uploading: false,
            },
          ];
        } else {
          this.uploadedAudio = [];
        }
      },
    },
    // 监听分析视频文件地址变化
    analysisVideoUrl: {
      handler(newVal) {
        if (newVal) {
          this.autoExtractVideoFrames(newVal);
        } else {
          this.videoFrames = [];
        }
      },
    },
    // 监听学生名变化
    studentName: {
      handler(newVal) {
        this.studentName = newVal;
      },
    },
    studentId: {
      handler(newVal) {
        this.studentId = newVal;
        if (this.studentId) {
          this.getRecordList();
        } else {
          this.recordList = [];
        }
      },
    },
    // 监听文本变化
    text: {
      handler(newVal) {
        this.observationContent = newVal;
      },
    },
  },
  data() {
    return {
      selectIndex: -1,
      showSaveType: false,
      studentNameLocal: "",
      rating: 5,
      observationContent: "",
      // 分页相关
      pageInfo: {
        total: 20,
        pageSize: 5,
        currentPage: 1,
      },
      recordId: "",
      scores: {
        health: 0,
        language: 0,
        social: 0,
        science: 0,
        art: 0,
      },
      token: "",
      caseList: [
        { name: "周小米", time: "保存于：2025/11/02 09:22:06" },
        { name: "周小米", time: "2025/11/07 11:22:06" },
        { name: "周小米", time: "2025/11/11 22:22:06" },
      ],
      // 图片上传相关
      uploadedImages: [],
      // 音频上传相关
      uploadedAudio: [], // 改为数组格式
      // 视频抽帧相关
      videoFrames: [],
      // 存储创建的URL对象，以便在组件销毁时释放
      createdUrls: [],
      radarChartInstance: null,
      bot_image: {
        id: "7587708374930751539",
        name: "图片分析",
        description: "根据图片内容生成分析结果",
        streamOutput: "",
      },
      bot_audio: {
        id: "7587651652195205160",
        name: "语音分析",
        description: "根据语音内容生成分析结果",
        streamOutput: "",
      },
      bot_text: {
        id: "7587708374930751539",
        name: "文字分析",
        description: "根据文字内容生成分析结果",
        streamOutput: "",
      },
      bot_filed: {
        id: "7678237088059375642",
        name: "五大领域分析",
        description: "根据白描文字分析五大领域",
        streamOutput: "",
      },
      bot_text2: {
        id: "7587703148098093056",
        name: "语义助手",
        description: "根据文字内容生成分析结果",
        streamOutput: "",
      },
      // 模块9和模块10的数据
      module9Data: null, // 领域数据
      module10Data: null, // 五维图打分数据
      bot_video: {
        id: "7591079711976341510",
        name: "视频分析",
        description: "根据视频内容生成分析结果",
        streamOutput: "",
      },
      // 流数据处理相关变量
      streamOutput: "",
      fullStreamText: "",
      displayText: "",
      typewriterTimer: null,
      // 加载状态相关
      loading: {
        uploadImage: false, // 图片上传加载状态
        createWhiteboard: false, // 生成白描加载状态
        uploadAudio: false, // 音频上传加载状态
        audioToText: false, // 音频转文字加载状态
        createAudioWhiteboard: false, // 根据音频生成白描加载状态
        uploadVideoFrames: false, // 视频帧上传加载状态
        createVideoWhiteboard: false, // 根据视频生成白描加载状态
        field: false, // 五大领域分析加载状态
        text2: false, // 语义助手加载状态
      },
    };
  },
  components: {
    VueMarkdown,
  },
  created() {
    // 初始化学生姓名
    if (this.studentName) {
      this.studentNameLocal = this.studentName;
    }

    if (this.studentId) {
      this.getRecordList();
    }

    // 初始化分析图片数组
    if (this.analysisImages && this.analysisImages.length > 0) {
      this.uploadedImages = this.analysisImages.map((img) => ({
        id: img || "",
        url: img || "",
        uploading: false,
      }));
    }

    // 初始化分析音频文件地址
    if (this.analysisAudioUrl) {
      this.uploadedAudio = [
        {
          id: this.analysisAudioUrl || "",
          name: this.analysisAudioUrl.split("/").pop() || "audio.mp3",
          uploading: false,
        },
      ];
    }

    // 初始化分析视频文件地址并自动提取帧
    if (this.analysisVideoUrl) {
      this.autoExtractVideoFrames(this.analysisVideoUrl);
    }

    if (this.text) {
      this.observationContent = this.text;
    }
  },
  mounted() {
    if (this.userInfo) {
      this.initToken();
    }
    this.initRadarChart();
    this.$watch(
      "scores",
      () => {
        this.updateRadarChart();
      },
      { deep: true },
    );
  },
  methods: {
    handleChangeCase(item) {
      this.recordId = item.id;
      // 先尝试从列表项直接回显数据
      if (item.student_name) {
        this.studentNameLocal = item.student_name;
      }
      if (item.content) {
        this.observationContent = item.content;
      }
      if (item.all_words) {
        this.bot_filed.streamOutput = item.all_words;
        // 提取模块9和模块10数据
        this.extractModuleData(item.all_words);
      }
      if (item.photos_info) {
        this.bot_image.streamOutput = item.photos_info;
      }
      if (item.audios_txt) {
        this.bot_audio.streamOutput = item.audios_txt;
      }
      if (item.videos_txt) {
        this.bot_video.streamOutput = item.videos_txt;
      }
      // 如果有评分数据，更新五维图
      if (item.scores && Array.isArray(item.scores)) {
        this.updateScoresFromArray(item.scores);
      }
      // 如果有图片数据，更新上传图片列表
      if (item.photos) {
        try {
          const photos = typeof item.photos === "string" ? JSON.parse(item.photos) : item.photos;
          if (Array.isArray(photos)) {
            this.uploadedImages = photos.map((photo, index) => ({
              id: photo.id || "",
              url: photo.url || "",
              name: photo.name || `image${index + 1}.jpg`,
              uploading: false,
            }));
          }
        } catch (e) {
          console.error("解析photos失败:", e);
        }
      }
      // 如果有音频数据，更新上传音频列表
      if (item.audios) {
        try {
          const audios = typeof item.audios === "string" ? JSON.parse(item.audios) : item.audios;
          if (Array.isArray(audios)) {
            this.uploadedAudio = audios.map((audio, index) => ({
              id: audio.id || "",
              name: audio.name || `audio${index + 1}.mp3`,
              uploading: false,
            }));
          }
        } catch (e) {
          console.error("解析audios失败:", e);
        }
      }
      // 如果有视频数据，更新视频抽帧列表
      if (item.videos) {
        try {
          const videos = typeof item.videos === "string" ? JSON.parse(item.videos) : item.videos;
          if (Array.isArray(videos)) {
            this.videoFrames = videos.map((video, index) => ({
              id: video.id || "",
              src: video.src || "",
              name: video.name || `frame${index + 1}.jpg`,
              selected: false,
            }));
          }
        } catch (e) {
          console.error("解析videos失败:", e);
        }
      }
      // 调用getRecordDetail获取完整详情（可选）
      // this.getRecordDetail();
    },
    onChangeExm(e) {
      this.pageInfo.currentPage = e;
      this.getRecordList();
    },
    handleShowSave() {
      this.showSaveType = true;
    },
    getRecordList() {
      axios
        .post(
          aiApi.main + aiApi.getRecordList,
          qs.stringify({
            student_id: this.studentId,
            currentPage: this.pageInfo.currentPage,
            pageSize: this.pageInfo.pageSize,
            school_id: this.userInfo.school_id,
          }),
          {
            headers: {
              Authorization: this.headers,
              "Content-Type": "application/x-www-form-urlencoded",
            },
          },
        )
        .then((res) => {
          if (res.data.result) {
            this.caseList = res.data.data || [];
          } else {
            this.$message.error(res.data.message || "获取记录失败，请重试");
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("获取记录失败，请重试");
        });
    },
    // getRecordDetail() {
    //   axios
    //     .post(aiApi.main + aiApi.getRecordDetail, qs.stringify({
    //       record_id: this.recordId,
    //     }), {
    //       headers: {
    //         'Authorization': this.headers,
    //         'Content-Type': 'application/x-www-form-urlencoded'
    //       }
    //     })
    //     .then((res) => {
    //       if (res.data.result) {
    //       } else {
    //         this.$message.error(res.data.message || "获取记录详情失败，请重试");
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       this.$message.error("获取记录详情失败，请重试");
    //     });
    // },
    handleDeleteCase(item) {
      this.$confirm({
        title: "提示",
        content: "确认删除吗？不可恢复",
        centered: true,
        onOk: () => {
          axios
            .post(
              aiApi.main + aiApi.deleteRecord,
              qs.stringify({
                record_id: item.id,
              }),
              {
                headers: {
                  Authorization: this.headers,
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              },
            )
            .then((res) => {
              if (res.data.result) {
                this.$message.success("删除成功！");
                this.getRecordList();
              } else {
                this.$message.error(res.data.message || "删除失败，请重试");
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message.error("删除失败，请重试");
            });
        },
      });
    },
    handleSave() {
      //加载状态
      const load = this.$message.loading({
        lock: true,
        text: "正在保存...",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios({
        method: "POST",
        url: reportApi.main + reportApi.saveFiledAiData,
        headers: {
          Authorization: this.headers,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: qs.stringify({
          all_words: this.bot_filed.streamOutput,
          student_name: this.studentName,
          student_id: this.studentId,
          school_id: this.userInfo.school_id,
          content: this.observationContent,
          record_id: this.selectIndex === -1 ? "" : this.recordId,
          audios: this.uploadedAudio.map((audio) => ({
            id: audio.id || "",
            name: audio.name || "audio.mp3",
          })),
          audios_txt: this.bot_audio.streamOutput,
          photos: this.uploadedImages.map((img) => ({
            id: img.id || "",
            name: img.name || "image.jpg",
          })),
          photos_info: this.bot_image.streamOutput,
          videos: this.videoFrames.map((frame) => ({
            id: frame.id || "",
            name: frame.name || "frame.jpg",
          })),
          videos_txt: this.bot_video.streamOutput,
        }),
      })
        .then((res) => {
          load();
          if (res.data.result) {
            this.$message.success("保存成功！");
            this.showSaveType = false;
            this.recordId = res.data.data.id || "";
            this.getRecordList();
          } else {
            this.$message.error(res.data.message || "保存失败，请重试");
          }
        })
        .catch((err) => {
          load();
          console.log(err);
          this.$message.error("保存失败，请重试");
        });
    },
    clearOutput() {
      this.bot_filed.streamOutput = "";
      this.observationContent = "";
      this.module9Data = null;
      this.module10Data = null;
      this.bot_text2.streamOutput = "";
      this.scores = {
        health: 0,
        language: 0,
        social: 0,
        science: 0,
        art: 0,
      };
    },
    // 采用领域和行为表现，将模块9数据抛出
    copyOutput() {
      if (!this.module9Data) {
        this.$message.warning("暂无领域和行为表现数据，请先完成分析");
        return;
      }
      // 通过事件将模块9数据抛出
      this.$emit("copy-output", this.module9Data);
      this.$message.success("数据已成功传递到观察记录页面");
    },
    // 提取模块9和模块10的数据
    extractModuleData(fullText) {
      try {
        // 提取模块9数据：领域数据
        const module9Regex = /模块9：结果表格\（JSON格式\）[\s\S]*?```json[\s\S]*?([\s\S]*?)```/;
        const module9Match = fullText.match(module9Regex);
        if (module9Match && module9Match[1]) {
          let module9Data = JSON.parse(module9Match[1].trim());
          // 对阶梯id进行去重处理
          module9Data = this.deduplicateLadderIds(module9Data);
          this.module9Data = module9Data;
          console.log("模块9数据(去重后):", this.module9Data);
        }

        // 提取模块10数据：五维图打分数据
        const module10Regex = /模块10：评分结果\（JSON格式\）[\s\S]*?```json[\s\S]*?([\s\S]*?)```/;
        const module10Match = fullText.match(module10Regex);
        if (module10Match && module10Match[1]) {
          this.module10Data = JSON.parse(module10Match[1].trim());
          console.log("模块10数据:", this.module10Data);
          // 更新五维图评分
          this.updateScoresFromModule10();
        }
      } catch (error) {
        console.error("提取模块数据失败:", error);
      }
    },
    // 根据模块10数据更新五维图评分
    updateScoresFromModule10() {
      if (
        !this.module10Data ||
        !this.module10Data.student_assessment ||
        !this.module10Data.student_assessment.domain_assessments
      ) {
        return;
      }

      const domainAssessments = this.module10Data.student_assessment
        .domain_assessments;
      domainAssessments.forEach((domain) => {
        const domainName = domain.domain;
        let scoreValue = 0;

        // 解析分数值，如 "3.8/5" -> 3.8
        if (domain.domain_score && domain.domain_score !== "未观察") {
          scoreValue = parseFloat(domain.domain_score.split("/")[0]) || 0;
        }

        // 更新对应的分数
        switch (domainName) {
          case "健康":
            this.scores.health = scoreValue;
            break;
          case "语言":
            this.scores.language = scoreValue;
            break;
          case "社会":
            this.scores.social = scoreValue;
            break;
          case "科学":
            this.scores.science = scoreValue;
            break;
          case "艺术":
            this.scores.art = scoreValue;
            break;
          default:
            break;
        }
      });

      // 更新雷达图
      this.updateRadarChart();
    },
    // 对模块9数据中的阶梯id进行去重
    deduplicateLadderIds(module9Data) {
      if (!module9Data || typeof module9Data !== 'object') {
        return module9Data;
      }
      
      // 模块9数据格式: { "module1_result_table": [[ {...}, {...} ]] }
      if (module9Data.module1_result_table && Array.isArray(module9Data.module1_result_table)) {
        // 遍历外层数组
        module9Data.module1_result_table = module9Data.module1_result_table.map(innerArray => {
          if (!Array.isArray(innerArray)) {
            return innerArray;
          }
          
          // 遍历内层数组中的每个领域项
          return innerArray.map(item => {
            // 如果没有阶梯集合，直接返回
            if (!item || typeof item !== 'object' || !item["阶梯集合"] || !Array.isArray(item["阶梯集合"])) {
              return item;
            }
            
            // 根据阶梯id进行去重
            const seenIds = new Set();
            const uniqueLadders = item["阶梯集合"].filter(ladder => {
              if (!ladder || typeof ladder !== 'object') {
                return false;
              }
              const ladderId = ladder["阶梯id"];
              if (seenIds.has(ladderId)) {
                return false;
              }
              seenIds.add(ladderId);
              return true;
            });
            
            // 返回去重后的对象
            return {
              ...item,
              "阶梯集合": uniqueLadders
            };
          });
        });
      }
      
      return module9Data;
    },
    // 根据数组格式的评分数据更新五维图评分
    updateScoresFromArray(scoresArray) {
      if (!scoresArray || !Array.isArray(scoresArray)) {
        return;
      }

      scoresArray.forEach((item) => {
        if (item.domain === "健康" || item.domain === "健康领域") {
          this.scores.health = parseFloat(item.score) || 0;
        } else if (item.domain === "语言" || item.domain === "语言领域") {
          this.scores.language = parseFloat(item.score) || 0;
        } else if (item.domain === "社会" || item.domain === "社会领域") {
          this.scores.social = parseFloat(item.score) || 0;
        } else if (item.domain === "科学" || item.domain === "科学领域") {
          this.scores.science = parseFloat(item.score) || 0;
        } else if (item.domain === "艺术" || item.domain === "艺术领域") {
          this.scores.art = parseFloat(item.score) || 0;
        }
      });

      // 更新雷达图
      this.updateRadarChart();
    },
    async checkText() {
      this.streamOutput = "";
      await send_coze_to_whiteboard(
        this.token,
        this.bot_text2.id, // 使用默认ID或配置的ID
        this.userInfo.id,
        this.observationContent,
        (text) => {
          // 实时更新数据（打字机效果）
          this.bot_text2.streamOutput = text;
        },
        () => {},
        this.userInfo.school_id,
      );

      this.loading.text2 = false; // 生成白描完成，设置加载状态为false

      this.$message.success("白描生成完成！");
    },
    async handleAnalysis() {
      // send_coze_text_non_stream(
      //   this.token,
      //   this.bot_filed.id,
      //   this.userInfo.id,
      //   this.observationContent,
      //   (text) => {
      //     // 实时更新数据（打字机效果）
      //     this.bot_filed.streamOutput = text;
      //     console.log(text);
      //   }
      // );
      this.bot_filed.streamOutput = "";
      this.loading.field = true; // 开始生成白描，设置加载状态为true
      try {
        await send_coze_to_whiteboard(
          this.token,
          this.bot_filed.id,
          this.userInfo.id,
          this.observationContent,
          (text) => {
            // 实时更新数据（打字机效果）
            // this.bot_filed.streamOutput = text;
            //去除包含### 模块 8以及后面的所有内容
            this.bot_filed.streamOutput = text.replace(/模块9.*$/, "").trim();
            // this.bot_filed.streamOutput = text[1].content;
          },
          (fullText) => {
            console.log(fullText, "fullText");
            // 提取模块9和模块10的数据
            this.extractModuleData(fullText);
            //模块9及以后得数据全部截取，不输出
            console.log(
              fullText,
              "ahhahaha",
              fullText.replace(/模块9.*$/, "").trim(),
            );
            this.bot_filed.streamOutput = fullText
              .replace(/模块9.*$/, "")
              .trim();
          },
          this.userInfo.school_id,
        );
        setTimeout(() => {
          this.loading.field = false; // 生成白描完成，设置加载状态为false
          this.$message.success("分析完成！");
        }, 500);
      } catch (error) {
        console.log(error);
        // 生成失败时关闭消息提示
        this.loading.field = false; // 生成白描失败，设置加载状态为false
        this.$message.error("白描生成失败，请重试");
      }
    },
    async handleCreateWhiteboard() {
      if (
        this.uploadedImages.length === 0 ||
        this.uploadedImages[0].id === ""
      ) {
        this.$message.error("请上传至少一张图片");
        return;
      }

      try {
        this.loading.createWhiteboard = true; // 开始生成白描，设置加载状态为true
        // 显示生成中消息提示

        this.streamOutput = "";
        await send_coze_image(
          this.token,
          this.bot_image.id,
          this.userInfo.id,
          this.uploadedImages.map((img) => img.id),
          (text) => {
            // 实时更新数据（打字机效果）
            this.bot_image.streamOutput = text;
          },
        );

        this.loading.createWhiteboard = false; // 生成白描完成，设置加载状态为false

        // 显示生成完成消息
        this.$message.success("白描生成完成！");
      } catch (error) {
        console.error("Error receiving stream:", error);
        // 生成失败时关闭消息提示
        this.$message.closeAll();
        this.loading.createWhiteboard = false; // 生成白描失败，设置加载状态为false
        this.$message.error("白描生成失败，请重试");
      }
    },

    // 提取流数据处理逻辑到单独的方法
    async processCozeStream(response, onDataReceived) {
      try {
        // 获取响应的可读流
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");

        // 存储完整的响应数据
        let fullResponse = "";

        // 循环读取流数据
        while (true) {
          const { done, value } = await reader.read();

          // 如果流已结束，退出循环
          if (done) {
            break;
          }

          // 解码并处理数据
          const chunk = decoder.decode(value);
          fullResponse += chunk;

          // 处理coze的流式数据
          // coze的流式数据通常是多个JSON对象，每个对象以\n分隔
          const lines = fullResponse.split("\n");
          for (let i = 0; i < lines.length - 1; i++) {
            const line = lines[i];
            if (line.trim() === "") continue;
            if (line.startsWith("data: ")) {
              const data = line.substring(6);
              try {
                const json = JSON.parse(data);
                // 调用回调函数处理接收到的数据
                if (json.content && json.content.length > 0) {
                  onDataReceived(json.content);
                }
              } catch (error) {
                console.error("Error parsing JSON:", error);
              }
            }
          }

          // 更新fullResponse，只保留未处理的部分
          fullResponse = lines[lines.length - 1];
        }
      } catch (error) {
        console.error("Error processing stream:", error);
      }
    },
    initToken() {
      axios
        .get(
          "https://czcszpg.dzuo.net/eval/aiweb/getToken.htm?user_id=" +
            this.userInfo.id +
            "&name=dzuo",
        )
        .then((response) => {
          console.log(response.data);
          // 处理成功响应
          this.token = response.data.data;
        })
        .catch(function(error) {
          // 处理错误响应
          console.error(error);
        });
    },
    // 初始化雷达图
    initRadarChart() {
      this.radarChartInstance = echarts.init(this.$refs.radarChart);
      this.updateRadarChart();
    },
    // 更新雷达图数据
    updateRadarChart() {
      const option = {
        // 设置图表边距
        grid: {
          left: "5%",
          right: "5%",
          top: "5%",
          bottom: "5%",
          containLabel: true,
        },
        radar: {
          // 调整雷达图内边距
          radius: "70%",
          center: ["50%", "55%"],
          indicator: [
            { name: "健康", max: 5 },
            { name: "语言", max: 5 },
            { name: "社会", max: 5 },
            { name: "科学", max: 5 },
            { name: "艺术", max: 5 },
          ],
          shape: "polygon",
          splitNumber: 5,
          // 调整指示器文字样式
          name: {
            textStyle: {
              fontSize: 12,
              color: "#333",
            },
            // 调整文字位置，避免被遮挡
            padding: 8,
          },
          // 调整分隔线样式
          splitLine: {
            lineStyle: {
              width: 1,
              color: "#e0e0e0",
            },
          },
          splitArea: {
            areaStyle: {
              color: ["#f9f9f9", "#f0f0f0"],
            },
          },
        },
        series: [
          {
            type: "radar",
            data: [
              {
                value: [
                  this.scores.health,
                  this.scores.language,
                  this.scores.social,
                  this.scores.science,
                  this.scores.art,
                ],
                name: "五大领域评分",
                // 调整系列样式
                areaStyle: {
                  color: "rgba(103, 177, 220, 0.3)",
                },
                lineStyle: {
                  width: 2,
                  color: "#67b1dc",
                },
                itemStyle: {
                  color: "#67b1dc",
                },
              },
            ],
          },
        ],
      };
      this.radarChartInstance.setOption(option);
      window.addEventListener("resize", () => {
        this.radarChartInstance.resize();
      });
    },

    // ---------------------- 新增：图片上传/删除方法 ----------------------
    async uploadImage(e) {
      const files = e.target.files;
      if (files.length === 0) return;
      //files转换为数组
      const fileArray = Array.from(files);

      try {
        this.loading.uploadImage = true; // 开始上传，设置加载状态为true

        // 先将所有图片添加到uploadedImages数组，设置uploading: true
        const tempImages = fileArray.map((file) => ({
          id: "", // 使用文件名作为临时id
          url: "",
          uploading: true,
          file: file,
        }));

        this.uploadedImages = [...this.uploadedImages, ...tempImages];

        // 使用Promise.all等待所有图片本地预览加载完成
        const previewPromises = tempImages.map((img, index) => {
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (event) => {
              // 更新对应图片的url
              this.uploadedImages[
                this.uploadedImages.length - tempImages.length + index
              ].url = event.target.result;
              resolve();
            };
            reader.readAsDataURL(img.file);
          });
        });

        await Promise.all(previewPromises);

        // 后台上传图片到Coze服务器
        const uploadResults = await batchUploadFilesToCoze(
          fileArray,
          this.token,
        );

        // 更新上传结果的id和上传状态
        uploadResults.forEach((result, index) => {
          // 找到本次上传的对应图片（使用索引定位，更准确）
          const imgIndex =
            this.uploadedImages.length - fileArray.length + index;
          if (imgIndex >= 0 && imgIndex < this.uploadedImages.length) {
            this.uploadedImages[imgIndex].id = result.file_id;
            this.uploadedImages[imgIndex].uploading = false; // 单个图片上传完成
            delete this.uploadedImages[imgIndex].file; // 清除临时存储的file对象
          }
        });

        this.loading.uploadImage = false; // 所有图片上传完成，设置加载状态为false

        // 清空input值，允许重复上传同一文件
        e.target.value = "";
      } catch (error) {
        console.error("图片上传失败:", error);
        this.loading.uploadImage = false; // 上传失败，设置加载状态为false
        // 可以在这里添加错误提示
      }
    },
    deleteImage(index) {
      this.uploadedImages.splice(index, 1);
    },

    // ---------------------- 新增：音频上传/删除方法 ----------------------
    async uploadAudio(e) {
      const file = e.target.files ? e.target.files[0] : e;
      if (!file) return;

      // 限制只能上传一个音频文件
      if (this.uploadedAudio.length >= 1) {
        this.$message.warning("只能上传一个音频文件");
        if (e.target.value) {
          e.target.value = "";
        }
        return;
      }

      // 限制文件大小（最大10MB）
      const maxSize = 10 * 1024 * 1024; // 10MB
      if (file.size > maxSize) {
        this.$message.error("音频文件大小不能超过10MB");
        if (e.target.value) {
          e.target.value = "";
        }
        return;
      }

      try {
        this.loading.uploadAudio = true; // 开始上传，设置加载状态为true

        // 先将音频添加到uploadedAudio数组，设置uploading: true
        const tempAudio = [
          {
            id: "",
            name: file.name,
            uploading: true,
            file: file,
          },
        ];

        this.uploadedAudio = [...this.uploadedAudio, ...tempAudio];

        // 后台上传音频到Coze服务器
        const uploadResults = await batchUploadFilesToCoze([file], this.token);

        // 更新上传结果的id和上传状态
        uploadResults.forEach((result, index) => {
          // 找到本次上传的对应音频
          const audioIndex =
            this.uploadedAudio.length - tempAudio.length + index;
          if (audioIndex >= 0 && audioIndex < this.uploadedAudio.length) {
            this.uploadedAudio[audioIndex].id = result.file_id;
            this.uploadedAudio[audioIndex].uploading = false; // 音频上传完成
            delete this.uploadedAudio[audioIndex].file; // 清除临时存储的file对象
          }
        });

        this.loading.uploadAudio = false; // 音频上传完成，设置加载状态为false

        // 清空input值，允许重复上传同一文件
        if (e.target.value) {
          e.target.value = "";
        }
      } catch (error) {
        console.error("音频上传失败:", error);
        this.loading.uploadAudio = false; // 上传失败，设置加载状态为false
        this.$message.error("音频上传失败，请重试");
      }
    },
    deleteAudio(index) {
      this.uploadedAudio.splice(index, 1);
    },

    // 自动提取视频帧
    autoExtractVideoFrames(videoUrl) {
      // 创建视频元素
      const video = document.createElement("video");
      // 跨域处理
      video.crossOrigin = "anonymous";
      // 静音播放（避免需要用户交互）
      video.muted = true;
      // 隐藏视频元素
      video.style.display = "none";
      // 预加载元数据
      video.preload = "metadata";

      // 添加到DOM（某些浏览器需要视频元素在DOM中才能正常加载）
      document.body.appendChild(video);

      // 监听视频加载元数据完成事件
      video.onloadedmetadata = () => {
        // 创建canvas用于绘制视频帧
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // 设置canvas大小
        canvas.width = 60;
        canvas.height = 60;

        const duration = video.duration;
        const frameCount = 20;
        const interval = duration > 20 ? duration / frameCount : 1; // 大于20秒平均取20帧，否则每1秒取1帧

        // 提取视频帧
        const frames = [];

        // 使用递归方式提取帧
        const extractFrame = (index) => {
          if (index >= frameCount) {
            // 所有帧提取完成
            this.videoFrames = frames;
            // 清理视频元素
            document.body.removeChild(video);
            return;
          }

          // 设置当前时间
          const targetTime = Math.min(index * interval, duration);
          video.currentTime = targetTime;

          // 监听当前帧加载完成
          video.onseeked = () => {
            try {
              // 绘制当前帧到canvas
              ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

              // 验证帧是否为黑色
              const imageData = ctx.getImageData(
                0,
                0,
                canvas.width,
                canvas.height,
              );
              const data = imageData.data;
              let isBlack = true;

              for (let i = 0; i < data.length; i += 4) {
                if (data[i] !== 0 || data[i + 1] !== 0 || data[i + 2] !== 0) {
                  isBlack = false;
                  break;
                }
              }

              if (isBlack) {
                // 尝试重新绘制
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
              }

              // 将canvas转换为base64
              const frameData = {
                src: canvas.toDataURL("image/jpeg"),
                selected: false,
              };

              // 添加到帧数组
              frames.push(frameData);
              // 提取下一帧
              extractFrame(index + 1);
            } catch (error) {
              console.error("提取第", index + 1, "帧失败:", error);
              // 即使出错也继续提取下一帧
              extractFrame(index + 1);
            }
          };

          // 监听seek错误
          video.onseeking = () => {
            console.log("正在定位到时间点:", targetTime);
          };
        };

        // 开始提取帧
        extractFrame(0);
      };

      // 监听视频可以播放事件
      video.oncanplay = () => {};

      // 监听视频加载完成事件
      video.oncanplaythrough = () => {};

      // 监听视频加载错误
      video.onerror = (error) => {
        console.error(
          "视频错误信息:",
          video.error ? video.error.message : "未知",
        );
        // 清理视频元素
        if (video.parentNode) {
          document.body.removeChild(video);
        }
      };

      // 监听视频加载中止
      video.onabort = () => {
        // 清理视频元素
        if (video.parentNode) {
          document.body.removeChild(video);
        }
      };

      // 设置视频源
      video.src = videoUrl;
      // 触发视频加载
      video.load();
    },

    // ---------------------- 新增：视频上传/删除方法 ----------------------
    uploadVideo(e) {
      const file = e.target.files[0];
      if (!file) return;

      // 创建视频元素
      const video = document.createElement("video");
      video.preload = "metadata";

      // 监听视频加载完成事件
      video.onloadedmetadata = () => {
        // 创建canvas用于绘制视频帧
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // 设置canvas大小
        canvas.width = 60;
        canvas.height = 60;

        const duration = video.duration;
        const frameCount = 20;
        const interval = duration > 20 ? duration / frameCount : 1; // 大于20秒平均取20帧，否则每1秒取1帧

        // 提取视频帧
        const frames = [];

        // 使用递归方式提取帧
        const extractFrame = (index) => {
          if (index >= frameCount) {
            // 所有帧提取完成
            this.videoFrames = frames;
            return;
          }

          // 设置当前时间
          video.currentTime = Math.min(index * interval, duration);

          // 监听当前帧加载完成
          video.onseeked = () => {
            // 绘制当前帧到canvas
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

            // 将canvas转换为base64
            const frameData = {
              src: canvas.toDataURL("image/jpeg"),
              selected: false,
            };

            // 添加到帧数组
            frames.push(frameData);

            // 提取下一帧
            extractFrame(index + 1);
          };
        };

        // 开始提取帧
        extractFrame(0);
      };

      // 设置视频源
      const videoUrl = URL.createObjectURL(file);
      video.src = videoUrl;
      // 存储创建的URL对象，以便在组件销毁时释放
      this.createdUrls.push(videoUrl);

      e.target.value = "";
    },
    toggleFrameSelection(index) {
      // 切换帧的选中状态
      this.videoFrames[index].selected = !this.videoFrames[index].selected;
    },
    clearAllFrames() {
      this.videoFrames = [];
    },
    // 打字机效果方法
    typewriterEffect(fullText, speed = 50, onUpdate) {
      // 清除之前的定时器（如果存在）
      if (this.typewriterTimer) {
        clearInterval(this.typewriterTimer);
      }

      let currentIndex = 0;
      this.displayText = "";

      // 开始打字机效果
      this.typewriterTimer = setInterval(() => {
        if (currentIndex < fullText.length) {
          // 逐字符添加到显示文本
          this.displayText += fullText[currentIndex];
          currentIndex++;
          // 调用更新回调函数
          if (onUpdate) {
            onUpdate(this.displayText);
          }
        } else {
          // 打字完成，清除定时器
          clearInterval(this.typewriterTimer);
          this.typewriterTimer = null;
        }
      }, speed);
    },
    // 停止打字机效果
    stopTypewriter() {
      if (this.typewriterTimer) {
        clearInterval(this.typewriterTimer);
        this.typewriterTimer = null;
      }
    },
    // 清除打字机效果
    clearTypewriter() {
      this.stopTypewriter();
      this.displayText = "";
      this.fullStreamText = "";
    },
    // ---------------------- 新增：音频转文字方法 ----------------------
    async handleAudioToText() {
      if (this.uploadedAudio.length === 0 || this.uploadedAudio[0].id === "") {
        this.$message.error("请上传并等待音频完成上传");
        return;
      }

      try {
        this.loading.audioToText = true; // 开始转文字，设置加载状态为true

        this.bot_audio.streamOutput = "";
        await send_coze_audio_to_text(
          this.token,
          this.bot_audio.id, // 使用默认ID或配置的ID
          this.userInfo.id,
          this.uploadedAudio.map((audio) => audio.id),
          (text) => {
            // 实时更新数据（打字机效果）
            this.bot_audio.streamOutput = text;
          },
        );

        this.loading.audioToText = false; // 转文字完成，设置加载状态为false

        this.$message.success("音频转文字完成！");
      } catch (error) {
        console.error("音频转文字失败:", error);
        // 转文字失败时关闭消息提示
        this.loading.audioToText = false; // 转文字失败，设置加载状态为false
        this.$message.error("音频转文字失败，请重试");
      }
    },

    // ---------------------- 新增：根据音频生成白描方法 ----------------------
    async handleCreateAudioWhiteboard() {
      if (this.bot_audio.streamOutput.length === 0) {
        this.$message.error("请先将音频转换为文字");
        return;
      }

      try {
        this.loading.createAudioWhiteboard = true; // 开始生成白描，设置加载状态为true

        this.streamOutput = "";
        await send_coze_audio_to_whiteboard(
          this.token,
          this.bot_text.id, // 使用默认ID或配置的ID
          this.userInfo.id,
          this.bot_audio.streamOutput,
          (text) => {
            // 实时更新数据（打字机效果）
            this.bot_text.streamOutput = text;
          },
        );

        this.loading.createAudioWhiteboard = false; // 生成白描完成，设置加载状态为false

        this.$message.success("白描生成完成！");
      } catch (error) {
        console.error("音频生成白描失败:", error);
        // 生成失败时关闭消息提示
        this.loading.createAudioWhiteboard = false; // 生成白描失败，设置加载状态为false
        this.$message.error("白描生成失败，请重试");
      }
    },
    deleteAudio(index) {
      this.uploadedAudio.splice(index, 1);
    },

    // ---------------------- 新增：视频上传/删除方法 ----------------------
    uploadVideo(e) {
      const file = e.target.files[0];
      if (!file) return;

      // 创建视频元素
      const video = document.createElement("video");
      video.preload = "metadata";

      // 监听视频加载完成事件
      video.onloadedmetadata = () => {
        // 创建canvas用于绘制视频帧
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // 设置canvas大小
        canvas.width = 60;
        canvas.height = 60;

        const duration = video.duration;
        const frameCount = 20;
        const interval = duration > 20 ? duration / frameCount : 1; // 大于20秒平均取20帧，否则每1秒取1帧

        // 提取视频帧
        const frames = [];

        // 使用递归方式提取帧
        const extractFrame = (index) => {
          if (index >= frameCount) {
            // 所有帧提取完成
            this.videoFrames = frames;
            return;
          }

          // 设置当前时间
          video.currentTime = Math.min(index * interval, duration);

          // 监听当前帧加载完成
          video.onseeked = () => {
            // 绘制当前帧到canvas
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

            // 将canvas转换为base64
            const frameData = {
              src: canvas.toDataURL("image/jpeg"),
              selected: false,
            };

            // 添加到帧数组
            frames.push(frameData);

            // 提取下一帧
            extractFrame(index + 1);
          };
        };

        // 开始提取帧
        extractFrame(0);
      };

      // 设置视频源
      video.src = URL.createObjectURL(file);

      e.target.value = "";
    },
    toggleFrameSelection(index) {
      // 切换帧的选中状态
      this.videoFrames[index].selected = !this.videoFrames[index].selected;
    },
    clearAllFrames() {
      this.videoFrames = [];
    },
    // 打字机效果方法
    typewriterEffect(fullText, speed = 50, onUpdate) {
      // 清除之前的定时器（如果存在）
      if (this.typewriterTimer) {
        clearInterval(this.typewriterTimer);
      }

      let currentIndex = 0;
      this.displayText = "";

      // 开始打字机效果
      this.typewriterTimer = setInterval(() => {
        if (currentIndex < fullText.length) {
          // 逐字符添加到显示文本
          this.displayText += fullText[currentIndex];
          currentIndex++;
          // 调用更新回调函数
          if (onUpdate) {
            onUpdate(this.displayText);
          }
        } else {
          // 打字完成，清除定时器
          clearInterval(this.typewriterTimer);
          this.typewriterTimer = null;
        }
      }, speed);
    },
    // 停止打字机效果
    stopTypewriter() {
      if (this.typewriterTimer) {
        clearInterval(this.typewriterTimer);
        this.typewriterTimer = null;
      }
    },
    // 清除打字机效果
    clearTypewriter() {
      this.stopTypewriter();
      this.displayText = "";
      this.fullStreamText = "";
    },

    // ---------------------- 新增：视频帧分析方法 ----------------------
    async handleCreateVideoWhiteboard() {
      // 获取选中的视频帧（如果没有选中则默认全部）
      const selectedFrames = this.videoFrames.filter(
        (frame) => frame.selected || this.videoFrames.every((f) => !f.selected),
      );

      if (selectedFrames.length === 0) {
        this.$message.error("请选择要分析的视频帧");
        return;
      }

      try {
        this.loading.uploadVideoFrames = true; // 开始上传视频帧
        this.loading.createVideoWhiteboard = true; // 开始生成白描

        // 将base64图片转换为File对象
        const frameFiles = await Promise.all(
          selectedFrames.map(async (frame, index) => {
            try {
              // 将base64转换为Blob
              const response = await fetch(frame.src);
              const blob = await response.blob();
              // 创建File对象
              return new File([blob], `video_frame_${index}.jpg`, {
                type: "image/jpeg",
              });
            } catch (error) {
              console.error(`转换视频帧${index}失败:`, error);
              return null;
            }
          }),
        ).then((files) => files.filter((file) => file !== null)); // 过滤掉转换失败的帧

        if (frameFiles.length === 0) {
          this.$message.error("所有视频帧转换失败，请重试");
          return;
        }

        // 批量上传视频帧到Coze
        const uploadedFrames = [];
        for (const file of frameFiles) {
          try {
            const uploadedFile = await uploadFileToCoze(file, this.token);
            uploadedFrames.push(uploadedFile);
          } catch (error) {
            console.error(`上传视频帧${file.name}失败:`, error);
            // 忽略上传失败的帧，继续上传其他帧
          }
        }

        if (uploadedFrames.length === 0) {
          this.$message.error("所有视频帧上传失败，请重试");
          return;
        }

        // 发送视频帧分析请求
        this.bot_video.streamOutput = "";
        await send_coze_video_frames(
          this.token,
          this.bot_video.id,
          this.userInfo.id,
          uploadedFrames.map((frame) => frame.file_id),
          (text) => {
            // 实时更新数据（打字机效果）
            this.bot_video.streamOutput = text;
          },
        );

        this.$message.success("视频帧分析完成！");
      } catch (error) {
        console.error("视频帧分析失败:", error);
        this.$message.error("视频帧分析失败，请重试");
      } finally {
        this.loading.uploadVideoFrames = false;
        this.loading.createVideoWhiteboard = false;
      }
    },
    // 复制文本到剪贴板
    copyToClipboard(text) {
      if (!text) {
        this.$message.error("请输入要复制的文本");
        return;
      }
      // 创建临时textarea元素
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);

      // 选中并复制文本
      textarea.select();
      document.execCommand("copy");

      // 移除临时元素
      document.body.removeChild(textarea);

      // 提示复制成功
      this.$message.success("已复制到剪贴板");
    },
  },
  beforeDestroy() {
    // 清理视频和画布元素，防止内存泄漏和无障碍访问问题

    // 释放所有创建的URL对象
    this.createdUrls.forEach((url) => {
      try {
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error("释放URL对象失败:", e);
      }
    });
    this.createdUrls = [];

    // 清理视频元素
    const videos = document.querySelectorAll("video");
    videos.forEach((video) => {
      video.pause();
      video.src = "";
      video.load();
      // 如果视频元素是动态创建的，从DOM中移除
      if (video.parentNode) {
        video.parentNode.removeChild(video);
      }
    });

    // 清理画布元素
    const canvases = document.querySelectorAll("canvas");
    canvases.forEach((canvas) => {
      const ctx = canvas.getContext("2d");
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
      // 如果画布元素是动态创建的，从DOM中移除
      if (canvas.parentNode) {
        canvas.parentNode.removeChild(canvas);
      }
    });

    // 清除视频帧数据
    this.videoFrames = [];

    // 确保没有焦点留在隐藏的元素上
    if (document.activeElement) {
      // 检查当前活跃元素是否有aria-hidden属性
      if (document.activeElement.getAttribute("aria-hidden") === "true") {
        document.activeElement.blur();
      }
    }

    // 查找并清理所有具有aria-hidden="true"且tabindex="0"的元素
    const hiddenFocusableElements = document.querySelectorAll(
      '[aria-hidden="true"][tabindex="0"]',
    );
    hiddenFocusableElements.forEach((element) => {
      element.blur();
      element.removeAttribute("tabindex");
      // 如果元素是动态创建的，从DOM中移除
      if (element.parentNode) {
        element.parentNode.removeChild(element);
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import "./markdown.css";
#app {
  overflow-y: scroll;
}
.student-info-row {
  margin-bottom: 10px;
}
.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.check-item {
  padding: 10px;
  width: calc(50% - 10px);
  margin: 5px;
  display: block;
  border-radius: 5px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #eee;
  position: relative;
  cursor: pointer;
  box-sizing: border-box;
  .tip {
    position: absolute;
    top: 2px;
    right: 3px;
    font-size: 10px;
    color: #67b1dc;
  }
  &.select {
    border: 1px solid #67b1dc;
    color: #67b1dc;
    background: #fafafc;
  }
}
/* 全局样式 */
.analysis-page {
  padding: 20px;
  background-color: #f5f7fa;
  box-sizing: border-box;

  .page-wrapper {
    background-color: #f5f7fa;
    max-width: 1300px;
    margin: 0 auto;
  }
}

/* 页面头部布局 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  color: #1f2937;
  font-size: 20px;
  font-weight: 600;
}

/* 右上角按钮样式 */
.header-actions {
  display: flex;
  gap: 8px;
}

.main-container {
  display: flex;
  gap: 20px;
  width: 100%;
}

.left-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;

  .head {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e5e7eb;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
}

.right-column {
  width: 370px;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  gap: 20px;
}

.card-wrapper {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  .head {
    li {
      font-size: 14px !important;
    }
  }
}

.module-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  padding-bottom: 8px;
}

.input-control {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 14px;
  width: 150px;
}

.textarea-control {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  box-sizing: border-box;
  &:focus {
    outline: none;
    border-color: #67b0db;
  }
}

.small-textarea {
  height: 80px !important;
  min-height: 80px;
}

.rating-star {
  display: inline-block;
  margin-left: 10px;
}

.star {
  color: #d1d5db;
  font-size: 16px;
  margin-right: 2px;
}

.star.active {
  color: #f59e0b;
}

.btn-group {
  margin-top: 12px;
  display: flex;
  gap: 10px;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary {
  background-color: #67b1dc;
  color: #ffffff;
}

.btn-primary:hover {
  background-color: #5599c0;
}

.btn-default {
  background-color: #f3f4f6;
  color: #1f2937;
}

.btn-default:hover {
  background-color: #e5e7eb;
}

.btn-danger {
  background-color: #dc2626;
  color: #ffffff;
}

.btn-danger:hover {
  background-color: #b91c1c;
}

.btn-small {
  padding: 4px 8px;
  font-size: 12px;
}

.btn-block {
  width: 100%;
  margin-top: 8px;
  margin-bottom: 8px;
}

/* 禁用状态按钮样式 */
.btn:disabled {
  background-color: #94a3b8;
  cursor: not-allowed;
  opacity: 0.6;
}

.result-header {
  display: flex;
  background-color: #e0f2fe;
  padding: 8px;
  border-radius: 4px 4px 0 0;
}

.header-item {
  flex: 1;
  font-weight: 600;
  font-size: 14px;
}

.result-content {
  border: 1px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 4px 4px;
}

.result-row {
  display: flex;
  padding: 8px;
  border-bottom: 1px solid #f3f4f6;
}

.result-row:last-child {
  border-bottom: none;
}

.result-cell {
  flex: 1;
  font-size: 14px;
  color: #4b5563;
}

/* 高亮词分析样式 */
.highlight-analysis {
  margin: 16px 0;
  padding: 12px;
  background-color: #f0f7ff;
  border-radius: 6px;
  border-left: 4px solid #67b1dc;
}

.highlight-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
}

.highlight-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 6px;
}

.highlight-tag {
  padding: 2px 8px;
  background-color: #67b1dc;
  color: #ffffff;
  border-radius: 12px;
  font-size: 12px;
}

.highlight-desc {
  font-size: 12px;
  color: #6b7280;
}

.analysis-detail {
  margin-top: 16px;
}

/* 分析标题粗体+蓝色样式 */
.analysis-title {
  margin: 16px 0 8px 0;
  font-size: 15px;
  font-weight: 700;
  color: #67b1dc;
  padding-bottom: 4px;
  border-bottom: 1px dashed #dbeafe;
}
.audio-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.analysis-detail p,
.analysis-detail li {
  font-size: 14px;
  color: #4b5563;
  line-height: 1.5;
}

.analysis-detail ul {
  padding-left: 20px;
  margin: 4px 0;
}

/* 逐句分析样式 */
.sentence-analysis {
  margin-top: 12px;
  padding: 10px;
  background-color: #f9fafb;
  border-radius: 4px;
}

.sentence-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
}

.sentence-item {
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
}

.sentence-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.sentence-text {
  font-size: 13px;
  color: #374151;
  margin: 0 0 4px 0;
}

.sentence-result {
  font-size: 12px;
  color: #4b5563;
  margin: 0;
  padding-left: 8px;
  border-left: 2px solid #93c5fd;
}

.score-container {
  display: flex;
  gap: 20px;
  align-items: center;
}

.radar-chart {
  width: 260px;
  height: 220px;
}

.score-slider-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.slider-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.slider-control {
  flex: 1;
  --ant-slider-track-background-color: #67b1dc;
  --ant-slider-track-background: #67b1dc;
  --ant-slider-handle-background-color: #67b1dc;
  --ant-slider-rail-background-color: #e5e7eb;
}

/* 调整滑块尺寸 */
.ant-slider {
  margin: 0;
}

.ant-slider-track {
  background-color: #67b1dc;
}

.ant-slider-rail {
  background-color: #e5e7eb;
  border-radius: 3px;
  height: 6px;
}

.ant-slider-handle {
  border-color: #67b1dc;
  background-color: #67b1dc;
}

.ant-slider-handle:focus {
  border-color: #67b1dc;
  box-shadow: 0 0 0 5px rgba(103, 177, 220, 0.2);
}

.case-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.case-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  background-color: #f9fafb;
  border-radius: 4px;
}

.case-header {
  display: flex;
  flex-direction: column;
}

.case-name {
  font-weight: 600;
  font-size: 14px;
  color: #1f2937;
}

.case-time {
  font-size: 12px;
  color: #6b7280;
}

.case-actions {
  display: flex;
  gap: 6px;
}

.tool-item {
  margin-bottom: 20px;
}

.tool-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
}

.tool-desc {
  font-size: 12px;
  color: #6b7280;
  margin: 8px 0 4px 0;
}

/* ---------------------- 新增：上传/删除相关样式 ---------------------- */
.upload-btn-group {
  margin-bottom: 12px;
}

.upload-btn {
  display: inline-block;
  cursor: pointer;
}

.file-input {
  display: none;
}

/* 图片预览项（包含删除按钮） */
.preview-item {
  position: relative;
}

.preview-img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
}

/* 加载效果样式 */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 视频抽帧样式 */
.video-frames {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 10px 0;
}

.frame-item {
  position: relative;
  width: 60px;
  height: 60px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.frame-item:hover {
  transform: scale(1.05);
}

.frame-item.selected {
  outline: 2px solid #409eff;
  border-radius: 4px;
}

.frame-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

/* 勾选标记样式 */
.check-mark {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 18px;
  height: 18px;
  background-color: #409eff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  z-index: 10;
}

.delete-btn {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #f56c6c;
  color: white;
  border: none;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.delete-btn:hover {
  background-color: #f78989;
}

/* 删除按钮样式 */
.delete-btn {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #dc2626;
  color: #ffffff;
  border: none;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.delete-btn:hover {
  background-color: #b91c1c;
  transform: scale(1.1);
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.3);
}

/* 音频项样式（包含删除按钮） */
.audio-item {
  padding: 8px;
  background-color: #f9fafb;
  border-radius: 4px;
  font-size: 12px;
  color: #4b5563;
  width: 100%;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  position: relative;

  i {
    font-size: 12px;
    color: #dc2626;
    cursor: pointer;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

/* 文件名和删除按钮容器 */
.audio-name {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 小删除图标按钮样式 */
.delete-btn-small {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #dc2626;
  color: #ffffff;
  border: none;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.delete-btn-small:hover {
  background-color: #b91c1c;
  transform: scale(1.1);
}

/* 占位符样式 */
.audio-placeholder,
.video-placeholder {
  padding: 8px;
  background-color: #f9fafb;
  border-radius: 4px;
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 8px;
  text-align: center;
}

.tool-desc {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.upload-preview,
.video-frames {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.mt-8 {
  margin-top: 8px;
}

/* 响应式适配 */
@media (max-width: 1200px) {
  .main-container {
    flex-direction: column;
  }
}
</style>
<style lang="scss">
.card-wrapper {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  .head {
    li {
      font-size: 14px !important;
    }
  }
}
</style>
